import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from './AppIcon';
import BrandMark from './BrandMark';
import useAuth from 'hooks/useAuth';

const menuItems = [
  {
    label: 'Dashboard',
    path: '/dashboard',
    icon: 'LayoutGrid'
  },
  {
    label: 'Trackers',
    path: '/ghana/trackers',
    icon: 'ClipboardList'
  },
  {
    label: 'DPAT Assessment',
    path: '/dpat-assessment',
    icon: 'ClipboardCheck'
  },
  {
    label: 'Progress Report',
    path: '/APR-report',
    icon: 'TrendingUp'
  },
  {
    label: 'APR Dashboard',
    path: '/program-performance',
    icon: 'TrendingUp'
  },
  {
    label: 'RCC',
    path: '/organizational-hierarchy',
    icon: 'Network'
  },
  {
    label: 'Performance Contract',
    path: '/automated-report-generation-system',
    icon: 'FileText'
  },
  {
    label: 'Consolidated Performance Contract',
    path: '/ghana/ohlgs-consolidated',
    icon: 'FileText'
  },
  {
    label: 'Settings',
    path: '/settings',
    icon: 'Settings'
  }
];

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const handleNavigation = (path) => {
    if (path) {
      navigate(path);
    }
  };

  const isActive = (path) => location?.pathname === path;

  return (
    <div
      className="w-64 h-screen text-white flex flex-col fixed left-0 top-0 shadow-xl"
      style={{
        background: 'linear-gradient(180deg, #16325a 0%, #0d1f3a 100%)'
      }}
    >
      <div className="p-6">
        <div className="flex items-center gap-3 mb-2">
          <BrandMark
            alt="DDDP logo"
            className="h-16 w-16 rounded-lg bg-white p-2 shadow-md"
          />
          <div>
            <h1 className="text-2xl font-bold text-white" style={{ letterSpacing: '-0.02em', fontWeight: '700' }}>DDDP</h1>
            <p className="text-sm text-gray-300" style={{ fontWeight: '500' }}>Ghana Districts</p>
          </div>
        </div>
      </div>

      <div className="h-1 flex">
        <div className="flex-1 bg-red-500"></div>
        <div className="flex-1 bg-yellow-500"></div>
        <div className="flex-1 bg-green-500"></div>
      </div>

      <nav className="flex-1 overflow-y-auto px-4 py-6">
        <ul className="space-y-2">
          {menuItems.map((item) => (
            <li key={item.path}>
              <button
                onClick={() => handleNavigation(item.path)}
                className="w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors duration-200"
                style={{
                  backgroundColor: isActive(item.path) ? 'rgba(255, 255, 255, 0.15)' : 'transparent',
                  fontWeight: isActive(item.path) ? '600' : '500'
                }}
                onMouseEnter={(event) => {
                  if (!isActive(item.path)) {
                    event.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                  }
                }}
                onMouseLeave={(event) => {
                  if (!isActive(item.path)) {
                    event.currentTarget.style.backgroundColor = 'transparent';
                  }
                }}
              >
                <Icon name={item.icon} className="w-5 h-5" />
                <span className="text-base">{item.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>

      <div className="p-4 border-t" style={{ borderColor: 'rgba(255, 255, 255, 0.1)' }}>
        <div
          className="rounded-lg border px-3 py-3"
          style={{
            borderColor: 'rgba(255, 255, 255, 0.12)',
            backgroundColor: 'rgba(255, 255, 255, 0.06)'
          }}
        >
          <p className="text-xs uppercase tracking-wide text-gray-300 mb-1" style={{ fontWeight: '600' }}>Navigation</p>
          <p className="text-sm text-white font-semibold truncate" style={{ fontWeight: '600' }}>
            {user?.user?.fullName || 'User'}
          </p>
          <p className="text-xs text-gray-400 mt-1">
            Profile, settings, and logout are available from the top navigation menu.
          </p>
        </div>
        <p className="text-center text-xs text-gray-400 mt-3" style={{ fontWeight: '400' }}>
          (c) 2024 Ministry of Health
        </p>
      </div>
    </div>
  );
};

export default Sidebar;
